<div class="bd-form">
  <p></p>
  <input
    class="form-input"
    [placeholder]="'LANDING.BOOK_A_DEMO.FORM.NAME' | translate"
    #nameInput
    (blur)="modifyAttribute('name', $any($event.target)?.value)" />
  <div class="two-cols">
    <input
      class="form-input"
      #emailInput
      (blur)="modifyAttribute('email', $any($event.target)?.value)"
      [placeholder]="'LANDING.BOOK_A_DEMO.FORM.EMAIL' | translate" />
    <input
      class="form-input"
      #phoneInput
      (blur)="modifyAttribute('phone', $any($event.target)?.value)"
      [placeholder]="'LANDING.BOOK_A_DEMO.FORM.PHONE_NUMBER' | translate" />
  </div>
  <select #businessTypeInput class="form-input" (change)="modifyAttribute('businessType', $any($event.target)?.value)">
    <option value="" label="{{ 'LANDING.BOOK_A_DEMO.FORM.BUSINESS_TYPE' | translate }}"></option>
    <option *ngFor="let option of businessTypeOptions" [value]="option.key" [label]="option.label"></option>
  </select>
  <select #orderEstimateInput class="form-input" (change)="modifyAttribute('orderEstimate', $any($event.target)?.value)">
    <option value="" label="{{ 'LANDING.BOOK_A_DEMO.FORM.ORDER_ESTIMATE' | translate }}"></option>
    <option *ngFor="let option of orderEstimateOptions" [value]="option.key" [label]="option.label"></option>
  </select>
  <button (click)="sendLead()" class="landing-button secondary outlined">
    {{ "LANDING.BOOK_A_DEMO.FORM.BUTTON" | translate }}
  </button>
</div>
